export interface IEnkLinkLabelProps {
  text: string
  href?: string
  onClick?: () => void
}

export function EnkLinkLabel(props: IEnkLinkLabelProps) {
  const { text, href, onClick } = props
  return (
    <a href={href} onClick={onClick} className="font-semibold text-primary hover:text-primary/80">
      {text}
    </a>
  )
}
